import React, { Component } from 'react';
import styles from './shareUrl.scss';

class ShareUrlFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.setInputRef = this.setInputRef.bind(this);
    }

    setInputRef(node) {
        this.input = node;
    }

    copyTextToClipboard(copyText, ev) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(copyText).then(() => {
                this.setState({
                    displayCopied: true,
                });
            }, (err) => {
                console.error('Async: Could not copy text: ', err);
                this.setState({
                    displayCopied: false,
                });
            });
        } else {
            this.fallbackCopyText(ev);
        }
    }

    fallbackCopyText() {
        const isIphone = navigator.userAgent.match(/ipad|iphone/i);
        if (this.input) {
            let range; let
                selection;
            this.input.type = 'text';
            if (isIphone) {
                range = document.createRange();
                range.selectNodeContents(this.input);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                this.input.setSelectionRange(0, 999999);
            } else {
                this.input.select();
            }

            this.input.type = 'hidden';
        }
        this.setState({
            displayCopied: true,
        });
    }

    render() {
        const { url, urlText, buttonText, title, subTitle } = this.props;
        return (
            <React.Fragment>
                <div className={`section ${styles.searchFooter}`}>
                    <div className="container">
                        <div className="search-footer-content row">
                            <div className="search-footer-title col-md-6">
                                <h5 className="text-uppercase">{title}</h5>
                                <p>{subTitle}</p>
                            </div>
                            <div className={`col-md-4`}>
                                <input
                                    type="text"
                                    id="url"
                                    className="form-control search-footer-input"
                                    value={urlText || `${window.location.href}`}
                                    // ref={this.setInputRef}
                                    readOnly={false}
                                    contentEditable={true}
                                    onChange={() => {
                                        // do nothing
                                    }}
                                />
                                <input
                                    type="hidden"
                                    value={url || `${window.location.href}`}
                                    ref={this.setInputRef}
                                />
                            </div>
                            <div className="col-md-2">
                                <button
                                    type="button"
                                    className={`btn btn-large btn-default btn-block d-block text-uppercase`}
                                    onClick={() => {
                                        if (!this.state.displayCopied) {
                                            this.copyTextToClipboard(url || window.location.href);
                                        }
                                    }}
                                    disabled={this.state.displayCopied}
                                >
                                    {this.state.displayCopied ? 'Link Copied' : (buttonText || 'Copy Invite Link')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ShareUrlFooter;
